import React from "react";
import { PROFILE } from "../../mock";
import { Stethoscope, Heart } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-emerald-deep text-ivory pt-16 pb-8 relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 kerala-border opacity-70" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center">
              <Stethoscope className="w-5 h-5 text-gold" />
            </div>
            <div>
              <div className="font-display text-lg">{PROFILE.name}</div>
              <div className="text-xs tracking-widest uppercase text-gold">{PROFILE.tagline}</div>
            </div>
          </div>
          <p className="text-ivory/70 mt-5 leading-relaxed text-sm">
            A son of Mayyanad. Three decades in medical education, fifteen books, forty-two awards, and a lifetime of service to community medicine in Kerala.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-gold">Navigate</div>
          <ul className="mt-4 space-y-2 text-sm">
            {["About", "Journey", "Books", "Awards", "Sports", "Service", "Gallery", "Blog", "Events", "Contact"].map(l => (
              <li key={l}><a href={`#${l.toLowerCase()}`} className="text-ivory/80 hover:text-gold transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-gold">Reach Out</div>
          <p className="mt-4 text-sm text-ivory/80 leading-relaxed">{PROFILE.address}</p>
          <p className="mt-3 text-sm text-ivory/80">{PROFILE.phones[0]}</p>
          <a href="/admin" className="inline-block mt-5 text-xs uppercase tracking-widest text-gold hover:text-ivory border-b border-gold/40">Admin Panel →</a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-ivory/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-ivory/60">
        <div>© {year} {PROFILE.name}. All rights reserved.</div>
      </div>
    </footer>
  );
}
